/* eslint-disable no-undef */
import { serviceName } from '../resources/serviceConstants';
import {
  EFFORT_HISTORY_LIST_File_UPLOAD,
} from '../resources/endPoint';

export const effortUploadListForFileUplaod = (stardDate, endDate) => {
  // API call to fetch effort hsitory details
  const url = (stardDate && endDate)
    ? `${EFFORT_HISTORY_LIST_File_UPLOAD}&start-date=${stardDate}&end-date=${endDate}`
    : EFFORT_HISTORY_LIST_File_UPLOAD;

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.INTEGRATION_MS,
  };
};
